module.exports = __webpack_public_path__ + "static/media/13.5a6d0bc9.svg";